import HomePageTopStories from "@pages/Home/Overview/HomepageTopStories";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import type { SanitizedSectionArticle } from "@typings/Cue";
import cx from "classnames";

export type OverviewProps = {
  testId?: string | null;
  rootClassName?: string;
  data?: SanitizedSectionArticle[];
};

export default function Overview({
  testId = null,
  rootClassName,
  data,
}: OverviewProps): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);

  return (
    <section
      id="homepage-topstories-section"
      data-testid={testId}
      className={cx(
        rootClassName,
        "stories flex list-none flex-col",
        "lg:grid lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-4"
      )}
    >
      {data?.map((article, index: number) => {
        return article ? (
          <HomePageTopStories
            article={article}
            index={index}
            key={index}
            disablePaywall={
              OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER
            }
          />
        ) : null;
      })}
    </section>
  );
}
